import React, { useEffect, useState } from 'react';
import { GetJson } from '@awp/helpers/fetchReact';
import { FORM_MODE, Permissions, REST_API } from '@awp/constants';
import { Card, Container, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import AwpFormActionButtons from '@awp/components/Common/AwpFormActionButtons';
import AwpSpinner from '@awp/components/Common/AwpSpinner';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Authorize from '@components/Authorize';
import { AwpContainer } from '@components/Common/AwpContainer';
import { getListPageParams } from '@awp/helpers/navigation';
import { HazardForecastAreasService } from '@components/HazardForecastArea/HazardForecastAreasService';
import { useSelector } from 'react-redux';
import { getAvalancheGeographicAreas } from '@stores/avalancheSlice';

const HazardForecastAreaView = () => {
  const [entityData, setEntityData] = useState({});
  const [loading, setLoading] = useState(false);
  const { id: entityId } = useParams();
  const navigate = useNavigate();

  const avalanchePrograms = useSelector((state) => getAvalancheGeographicAreas(state, 'AVALANCHE PROGRAM'));

  const hazardForecastAreasService = new HazardForecastAreasService(FORM_MODE.VIEW);
  const { readOnly, title, relativePath, entityName, mode } = hazardForecastAreasService.crud;
  const listPageURL = getListPageParams();
  const baseUrl = REST_API.HAZARD_FORECAST_AREAS;

  useEffect(() => {
    setLoading(true);
    const url = `${baseUrl}${entityId}`;

    GetJson(url)
      .then((response) => response.json())
      .then((myEntityData) => {
        isValueEmpty(myEntityData) ? setEntityData({}) : setEntityData(myEntityData);

        setLoading(false);
      });
  }, []);

  const onClickEdit = () => {
    navigate(`${relativePath}${FORM_MODE.EDIT}/${entityId}`);
  };

  const onClickCancel = () => {
    navigate(`${relativePath}${listPageURL}`);
  };

  return (
    <AwpContainer>
      <Authorize requires={[Permissions.ReadAdminTools]}>
        <>
          {loading ? (
            <Container>
              <AwpSpinner />
            </Container>
          ) : (
            <>
              <Formik
                initialValues={{
                  validateOnMount: true,
                  ...HazardForecastAreasService.mapInitialValues(entityData, avalanchePrograms),
                }}
              >
                {(props) => (
                  <Form>
                    <Link className="awp-text-btn" to={`${relativePath}${listPageURL}`}>
                      {`List ${entityName}`}
                    </Link>
                    <span className="mx-3">&gt;</span>
                    <span>{isValueEmpty(entityData.Name) ? title : entityData.Name}</span>
                    <Card border="light" className="page-card">
                      <Card.Header>
                        <Row className="mt-4"></Row>
                        {hazardForecastAreasService.crud.getHeader()}
                      </Card.Header>
                      <Card.Body>
                        {HazardForecastAreasService.getFields({
                          entity: entityData,
                          avalanchePrograms,
                          readOnly: readOnly,
                          mode,
                        })}
                      </Card.Body>
                      <Card.Footer>
                        <Row className="my-2">
                          <AwpFormActionButtons
                            title=" "
                            id={2}
                            entityName={entityName}
                            onClickEdit={onClickEdit}
                            mode={mode}
                            permissions={[Permissions.WriteAdminTools]}
                            readOnly={readOnly}
                            isAlignLeft={true}
                            props={props}
                            btnCancelName={'Close'}
                            onClickCancel={onClickCancel}
                            isPristine={!props.dirty || props.isSubmitting}
                          />
                        </Row>
                      </Card.Footer>
                    </Card>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </>
      </Authorize>
    </AwpContainer>
  );
};

export default HazardForecastAreaView;
